export const defaultHeadline = "onboarding:title.awesome";

export const defaultDescription = "onboarding:default.description";
